// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3qVj7","head":"ProcedureTableInfo_head__3X9xh"};